<ngx-skeleton-loader *ngIf="!contentLoaded" [theme]="{ width: '100%', height: '100%', 'background-color': '#151515' }">
</ngx-skeleton-loader>
<div class="left_col scroll-view">
  <div class="clearfix"></div>
  <!-- sidebar menu -->
  <div id="sidebar-menu" class="main_menu_side hidden-print main_menu">
    <div class="menu_section">
      <ul class="nav side-menu">
        <!--li><a routerLink="/dashboard">
            <i class="fa fas-home"></i><span>Home </span> </a>
        </li-->
        <!--li (click)="SubmenuShow1 = !SubmenuShow1;"-->
        <li (click)="myApps=1">
          <a (click)="openhome();" [ngClass]="{'class1': myApps == 1}"><i class="las la-home"></i> 
            <!-- {{'MENU.LINE1' | translate}} -->
            My Apps
          </a>
          <!--ul class="nav child_menu show-m" [ngClass]="{'show-m': SubmenuShow1, 'hide-m': !SubmenuShow1}"-->
          <ul class="nav child_menu show-m">
            <li *ngFor="let section of userSectionlist">
              <a (click)="refreshLoad(section)" routerLink='/home'
                [queryParams]="{'sectionid': section.sectionId,'sectionName':section.sectionName}">
                <span>{{section.sectionName}}</span></a>
            </li>
            <li (click)="LoadApplication()" data-toggle="modal" data-target="#add-section">
              <a>
                <i class="las la-plus" (click)="LoadApplication()" data-toggle="modal"
                  style="padding-right:20px;vertical-align:middle" data-target="#add-section"></i>
                <span data-toggle="modal" data-target="#add-section" style="vertical-align:middle">
                  <!-- {{'MENU.LINE1_SUB' | translate}} -->
                  Add Section
                </span></a>
            </li>
          </ul>
          <!--li><a routerLink="/allappln">
            <i class="las la-plus" data-toggle="modal" data-target="#add-section"></i><span>Add Section +</span> </a>
        </li-->
          <!--/li-->
          <!--li><a><i class="fas fa-user-cog"></i></a>
          <ul>
            <li>
          <a>
            <i class="las la-plus" data-toggle="modal" data-target="#add-application"></i><span>Add Application</span>
          </a>
            </li>
          </ul>
        </li-->
        <li style="display:none">
          <a>
            <i class="fa fa-cog" aria-hidden="true"></i>Admin</a>
          <ul class="nav child_menu show-m">
            <li data-toggle="modal" (click)="clearapplndata()" data-target="#add-application">
              <a>
                <i class="las la-plus" data-toggle="modal" (click)="clearapplndata()"
                  data-target="#add-application"></i><span>Add Application</span>
              </a>
            </li>
          </ul>
        </li>
        <li (click)="myApps=2" [ngClass]="{'class2': myApps == 2}">
          <a (click)="opencatalog()" rel="no-refresh">
            <!--- routerLink="/AppCatalog"-->
            <i><img src="{{imgdynamicurl}}/assets/img/App_catalog.png" /></i>
            <!-- {{'MENU.LINE2' | translate}} -->
            App Catalog
          </a>
        </li>
        <!-- <li><a (click)="logout()"><i class="fa fa-sign-out"></i>Log out</a>
        </li> -->
      </ul>
    </div>
  </div>

  <!-- /sidebar menu -->
  <div class="modal fade" id="add-section" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable text-body">
      <div class="modal-content">
        <div class="modal-header border-0">
          <h5 class="modal-title" id="exampleModalLabel">
            <!-- {{'MENU.LINE1_SUB' | translate}} -->
            Add Section
          </h5>
          <button type="button" class="close" data-dismiss="modal" #closeBtn aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <!--(ngSubmit)="addsectionform.form.valid && onSubmit(addsectionform,'addsectionform')" -->
        <form name="addsectionform" id="addsectionform" #addsectionform="ngForm">
          <div class="modal-body">
            <!--div class="col-lg-4">Section Name</div>
            <div class="col-lg-8">
              <input type="text" class="form-control bg-light border-0 pl-5" id="inputTilename" [(ngModel)]="txtFilter"
              name="inputTilename" [(ngModel)] = "sectionname"placeholder="Enter Section Name..">
             </div-->
            <div class="form-group row">
              <!--label for="newsectionname" class="modal-label col-sm-3 col-form-label">Section Name</label-->
              <div class="col-lg-12 col-sm-12" style="padding-right:0px;padding-left:0px">
                <input pInputText type="text" id="sectionname" required
                  [ngClass]="{'is-invalid': addsectionform.submitted && sectionformvalue.length==0}"
                  placeholder="Enter Section Name" maxlength="50" class="form-control bg-light border-0"
                  [(ngModel)]="sectionname" name="sectionname" />
                <div *ngIf="addsectionform.submitted&&sectionformvalue.length==0" class="invalid-feedback">
                  <div *ngIf="addsectionform.submitted&&sectionformvalue.length==0">Please enter Section Name</div>
                </div>
              </div>
            </div>
            <div class="form-group search">
              <button class="border-0 bg-transparent pl-3">
                <svg width="16px" height="16px" viewBox="0 0 16 16" class="bi bi-search" fill="#717173"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                    d="M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z">
                  </path>
                  <path fill-rule="evenodd"
                    d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z">
                  </path>
                </svg>
              </button>
              <input type="text" class="form-control bg-light border-0 pl-5" id="inputTilename" [(ngModel)]="txtFilter"
                name="inputTilename" placeholder="Search...">
            </div>
            <div class="form-group">
              <div class="col-lg-12 col-sm-12">
                <ul class="list-group list-group-popup">
                  <!--li *ngFor="let app of applnList| appfilter:txtFilter | paginate: { itemsPerPage: 5, currentPage: p } | slice:(page-1)*limit:page*limit"-->
                  <li *ngFor="let app of applnList" class="list-group-item">
                    <!--span class="appitemspan">{{app.applnname}}</span> <input title="toggle all" type="checkbox"
                      [checked]="app.checked" [(ngModel)]="app.checked" class="all pull-right" [ngModelOptions]="{standalone: true}"-->
                    <span class="appitemspan">{{app.applnname}}</span>
                    <div class="pretty p-svg p-curve all pull-right">
                      <input title="toggle all" type="checkbox" [checked]="app.checked" [(ngModel)]="app.checked"
                        class="all pull-right" [ngModelOptions]="{standalone: true}">
                      <div class="state p-success">
                        <svg class="svg svg-icon" viewBox="0 0 20 20">
                          <path
                            d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                            style="stroke: white;fill:white;"></path>
                        </svg>
                        <label></label>
                      </div>
                    </div>
                    <!--div class="round">
                      <input type="checkbox" id="checkbox" />
                      <label for="checkbox"></label>
                    </div-->
                  </li>
                </ul>
                <!--pagination-controls style="margin-top:5px;padding:5px;text-align:center;" (pageChange)="p = $event">
                </pagination-controls-->
              </div>
            </div>
          </div>
          <div class="modal-footer border-0">
            <!--No remove section when adding new section-->
            <!--button type="button" class="btn btn-white border" (click)="RemoveSelection()">Remove Section</button-->
            <button type="submit" [disabled]="savesection" class="btn btn-primary" style="width:150px"
              (click)="onSubmit(addsectionform,'addsectionform');!savesection=savesection">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="modal fade" id="add-application" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable text-body">
      <div class="modal-content">
        <div class="modal-header border-0">
          <h5 class="modal-title" id="exampleModalLabel">Add new Application</h5>
          <button type="button" class="close" data-dismiss="modal" #closeBtnApps aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form name="addapplicationform" id="addapplicationform"
          (ngSubmit)="addapplicationform.form.valid && onSubmit(addapplicationform,'addapplicationform')"
          #addapplicationform="ngForm">
          <div class="modal-body">
            <div class="form-group row">
              <label for="applnname" class="modal-label col-sm-2 col-form-label">Name</label>
              <div class="col-sm-10" style="padding:1em">
                <input pInputText type="text" id="applnname" #applnname="ngModel" required
                  [ngClass]="{'is-invalid': addapplicationform.submitted && applnname.invalid}"
                  placeholder="Enter application name" class="form-control bg-light border-0"
                  [(ngModel)]="objapplnInfo.applnname" name="applnname" />
                <div *ngIf="applnname.submitted && applnname.invalid" class="invalid-feedback">
                  <div *ngIf="addapplicationform.errors.required">Please enter application name</div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="applnurl" class="modal-label col-sm-2 col-form-label">URL</label>
              <div class="col-sm-10" style="padding:1em">
                <input pInputText type="text" id="applnurl" #applnurl="ngModel" required
                  [ngClass]="{'is-invalid': addapplicationform.submitted && applnurl.invalid}"
                  placeholder="Enter application Url" class="form-control bg-light border-0"
                  [(ngModel)]="objapplnInfo.applnurl" name="applnurl" />
                <div *ngIf="applnurl.submitted && applnurl.invalid" class="invalid-feedback">
                  <div *ngIf="addapplicationform.errors.required">Please enter application Url</div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="applnlogo" class="modal-label col-sm-2 col-form-label">Logo</label>
              <div class="col-sm-10" style="padding:1em">
                <input pInputText type="text" id="applnlogo" #applnlogo="ngModel" required
                  [ngClass]="{'is-invalid': addapplicationform.submitted && applnlogo.invalid}"
                  placeholder="Enter application Logo" class="form-control bg-light border-0"
                  [(ngModel)]="objapplnInfo.applnlogo" name="applnlogo" />
                <div *ngIf="applnlogo.submitted && applnlogo.invalid" class="invalid-feedback">
                  <div *ngIf="addapplicationform.errors.required">Please enter application Logo</div>
                </div>
              </div>
            </div>
            <div class="form-group row d-flex justify-content-end">
              <button type="button" class="btn btn-primary" style="width:150px" (click)="clearapplndata()">
                Clear</button>
              <button type="submit" class="btn btn-primary" style="width:150px">
                <!--(click)="onSubmit(addapplicationform,'addapplicationform')"-->
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>